import styled from 'styled-components'
interface MAIN_STYLED_PROPS {
  fontSize?: string
}
export const Main = styled.main<MAIN_STYLED_PROPS>`
  height: 540px;
  overflow-y: scroll;
  overflow-x: hidden;
  font-family: 'GT America, regular';
  font-size: 12px;
  margin-bottom: 30px;
  text-transform: none;
  * {
    pointer-events: none;
    text-transform: none;
  }
  h3 {
    font-size: 20px;
    margin-top: 8px;
    margin-bottom: 8px;
    text-transform: capitalize;
    margin-left: 1px;
  }
  h4 {
    font-size: 12px;
    margin-left: 1px;
  }
  h5 {
    font-size: 12px;
    margin-bottom: 8px;
    margin-left: 1px;
  }
  p {
    font-family: 'GT America, regular';
    line-height: 1.33;
    margin-bottom: 8px;
  }
  span {
    font-size: 18px;
    font-family: 'GT America, regular';
  }
`
